import { isString as e } from "./index575.js";
class o extends Error {
  constructor(n) {
    super(n), this.name = "ElementPlusError";
  }
}
function i(r, n) {
  throw new o(`[${r}] ${n}`);
}
function u(r, n) {
  if (process.env.NODE_ENV !== "production") {
    const t = e(r) ? new o(`[${r}] ${n}`) : r;
    console.warn(t);
  }
}
export {
  u as debugWarn,
  i as throwError
};
